import { FC } from "react";
import { useSelector } from "react-redux";

import { BookingDateStrip } from "@models/components/booking.model";
import { RootState } from "@store/index";

import Dates from "./Dates/Dates";
import Header from "./Header/Header";

const DateStrip: FC<BookingDateStrip> = ({ isBookingDisable }) => {
  const { isAuthenticated } = useSelector((State: RootState) => State.local);
  return (
    <div
      className={`fg-booking-date-section ${isBookingDisable && "disabled"} ${isAuthenticated ? "fg-booking-date-mb" : ""}`}
      data-testid="date-strip-test"
    >
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <Header />
            <Dates />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateStrip;
